import React from 'react'

export const MainTitle = ({
  title,
  subtitle,
}: {
  title: string | React.ReactElement
  subtitle: string | React.ReactElement
}) => (
  <div className='col-12'>
    <div className='d-flex flex-column justify-content-end'>
      <div className='mc-text--center mc-mb-3'>
        <h1 className='mc-text-h3 mc-mb-3'>{title}</h1>
        <span className='mc-text-color--light mc-px-2'>{subtitle}</span>
      </div>
    </div>
  </div>
)
